var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCRUDPageLayout',{attrs:{"links":_vm.links},scopedSlots:_vm._u([{key:"tableName",fn:function(){return [_vm._v("ترتيب ظهور أسئلة طلب المنحة التدريبية ")]},proxy:true}])},[_c('v-container',[_c('SortQuestionTabs')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }